import React from 'react'

import ApplicationContainer from './ApplicationContainer'

const ApplicationProvider = () => (<ApplicationContainer />)

export default ApplicationProvider
